/* eslint-disable import/prefer-default-export */
import { useCallback, useState, useEffect } from 'react';

import { getWeeklyReportCalendar } from '../../../services/workReport';
import useToast from '../../../hooks/useToast';

/** @type {import("../../../adapters/weekly-report/weekly-report-calendar-adapter").TableDataCalendar} */
const initialStateCalendar = {
  endDate: { startDate: '', endDate: '' },
  firstWeek: { startDate: '', endDate: '' },
  pendingDates: []
};

/** @param {import('../hooks/useFilters').Filters} filters */
export const useCalendar = (filters) => {
  const [startDay, setStartDay] = useState(filters.fechaDesde);
  const [calendar, setCalendar] = useState(initialStateCalendar);
  const { setNewToast } = useToast();

  const updateStartDay = useCallback(
    /** @param {Date} newStartDay */ (newStartDay) => setStartDay(newStartDay),
    []
  );

  useEffect(() => {
    getWeeklyReportCalendar()
      .then(setCalendar)
      .catch((error) => setNewToast({ type: 'ERROR', message: error.message }));
  }, [setNewToast]);

  useEffect(() => {
    setStartDay(filters.fechaDesde);
  }, [filters]);

  return { calendar, startDay, updateStartDay };
};
